module.exports = __webpack_public_path__ + "static/img/4-3.206dd61a.png";